<template>
  <div :class="['thumbnail-grid', { centered }]">
    <div :class="['thumbnail-wrapper', { centered }]">
    <tile
      v-for="(item) in visibleItems"
      :key="item.itemID"
      :item="item"
      ref="thumbnails"
    />
    <tile
      v-if="itemsCount > visibleCount"
      :item="null"
    />
    </div>
    <div ref="loadTrigger" class="load-trigger"></div> <!-- Unsichtbarer Trigger fürs Nachladen -->
  </div>
</template>

<script>
import tile from "./tile.vue";
import { getBibTitle, getDepictionLabel, getCaveLabel } from "../utils/helpers";
export default {
  components: { tile },
  props: {
    items: Array, // Gesamtmenge an Bildern
    itemsCount: Number,
    centered: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processedItems: [],
      visibleCount: 20, // Starte mit 20 Bildern
      observer: null,
      steps: 20
    };
  },
  computed: {
    visibleItems() {
      return this.processedItems.slice(0, this.visibleCount); // Zeige nur die geladenen Bilder an
    },
  },
  mounted() {
    this.$log.debug("lazyTileGrid mounted", this.items);
    this.processItems(true);
    this.initObserver();
  },
  methods: {
    getDepictionLabel(pr){
      if (Object.keys(pr).length > 0){
        return getDepictionLabel(pr)
      }
      return ""
    },
    getMasterImage(pr){
      const images = pr.relatedImages ? pr.relatedImages : pr.images
      for (const image of images) {
        if (image.imageID === pr.masterImageID) {
          return image;
        }
      }
      return null

    },
    getPreselectedAnnotations(pr){
      if (pr.highlightedAnnotations)
      {
        this.$log.debug("getPreselectedAnnotations found highlightedAnnotations", pr.highlightedAnnotations.map(anno => JSON.parse(anno.w3c)))
        return pr.highlightedAnnotations.map(anno => {
            console.log("getPreselectedAnnotations blubb", anno)
            var w3cAnno = JSON.parse(anno.w3c)
            w3cAnno["motivation"] = "highlight"
            return { "w3c":w3cAnno, annotationID: anno.annotationID }
          }
        )
      }
      let annotations = []
      this.$log.debug("getPreselectedAnnotations", pr)
      const masterImage = this.getMasterImage(pr)
      if (masterImage){
        for (let annotation of pr.relatedAnnotationList){
          this.$log.debug("getPreselectedAnnotations annotation", annotation, "of depiction", pr.depictionID)
          if (annotation.image === masterImage.filename){
            let found = false

            for (let tag of annotation.tags){
              if (!pr.preSelected) break;
              for (let preselectedIco of pr.preSelected){
                if (tag.iconographyID === preselectedIco.iconographyID){
                  let w3cAnno =  JSON.parse(annotation.w3c) // clone annotation
                  w3cAnno["motivation"] = "highlight"
                  annotations.push(w3cAnno)
                  found = true
                  break;
                }
              }
              if (found) break;
            }

          }
        }
      }
      return annotations
    },
    processItems(startNew) {
      this.$log.debug("processItems", this.items);
      if (!startNew) {
        this.processedItems = []
      }
      let processedItem = null
      for (const item of this.items) {
        if (item) {
          if (item.depictionID) {
            this.$log.debug("processItems depictionID", item)
            const preSelected = this.getPreselectedAnnotations(item)
            processedItem = {
              label: this.getDepictionLabel(item),
              itemID: item.depictionID,
              itemType: "pr",
              masterImage: this.getMasterImage(item),
              preSelected: preSelected.map(anno =>
                {
                  if (anno.w3c){
                    return anno.w3c
                  }
                  return anno
                }
              ),
              link: "/pr/" + item.depictionID + "?" + (preSelected ? "&annotation=" + preSelected.map(anno => anno.annotationID).join(",") : "")
            };
          } else if (item.caveID) {
            processedItem = {
              label: getCaveLabel(item),
              itemID: item.caveID,
              itemType: "cave",
              masterImage: item.caveSketchList[0],
              preSelected: [],
              link: "/cave/" + item.caveID
            };
          } else if (item.iconographyID) {
            processedItem = {
              label: "KMT Entry " + item.iconographyID + " (" + item.text + ")",
              itemID: item.iconographyID,
              itemType: "iconography",
              masterImage: item.oe ? this.getMasterImage(item.oe) : null,
              preSelected: item.preSelected
            };
          } else if (item.annotatedBibliographyID) {
            processedItem = {
              label: getBibTitle(item) + " (Annotated Bibliography Entry " + item.annotatedBibliographyID + ")",
              itemID: item.annotatedBibliographyID,
              itemType: "bibliography",
              masterImage: null,
              preSelected: null // item.oe ? this.getPreselectedAnnotations(item.oe) : null
            };
          }
          if (this.processedItems.find((i) => i.itemID === processedItem.itemID)) {
            continue;
          } else {
            this.processedItems.push(processedItem);
          }
        }
        this.$log.debug("processedItems result", this.processedItems);
      }
    },
    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.loadMoreImages();
        }
      });

      if (this.$refs.loadTrigger) {
        this.observer.observe(this.$refs.loadTrigger);
      }
    },
    loadMoreImages() {
      if (this.visibleCount < this.itemsCount) {
        this.$emit("loadMore", this.visibleCount, this.steps);
        this.visibleCount += this.steps; // Lade 10 weitere Bilder nach
      }
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }

  },

  watch: {
    items() {
      if (this.processedItems.length > 0) {
        this.processItems(false);
      }
    },
  }
};
</script>

<style>
.thumbnail-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.thumbnail-grid.centered {
  justify-content: center; /* Nur wenn Prop aktiv */
  flex: 1 1 100%;
}

.thumbnail-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  max-width: 100%;              /* optional, falls sie nicht breiter als Container sein sollen */
}
.thumbnail-wrapper.centered {
  overflow-y: auto;
}
.load-trigger {
  height: 1px;
  width: 100%;
}
</style>